import { fetchTestCasesByTeam } from "../api/aiMetricsApi";
import { makeAdoMetricHook } from "./useAdoMetric";
import { ADO_QUERY_KEYS } from "./adoQueryKeys";

export const useAdoTestCasesByTeam = makeAdoMetricHook(
  ADO_QUERY_KEYS.testCasesByTeam,
  fetchTestCasesByTeam,
);
